/* ----------------------------------------------------------------------------------------------------
  IMPORTANT!
  The code below requires a developer to install and setup.
  Please do not simply copy/paste this onto your website.
  ---------------------------------------------------------------------------------------------------- */
  // Initiate Web Behaviour Tracking (this section MUST come prior any other dmPt calls)
  // Do not change this
  (function(w,d,u,t,o,c){w['dmtrackingobjectname']=o;c=d.createElement(t);c.async=1;c.src=u;t=d.getElementsByTagName
  (t)[0];t.parentNode.insertBefore(c,t);w[o]=w[o]||function(){(w[o].q=w[o].q||[]).push(arguments);};
  })(window, document, '//static.trackedweb.net/js/_dmptv4.js', 'script', 'dmPt');
  window.dmPt('create', 'DM-0950324295-02', 'juicyshop.se');
  window.dmPt('track');
  
/* ----------------------------------------------------------------------------------------------------
  Identify the contact:
  The code below needs to be executed on every single page, after the cart has been created.
  Failure to do so may result in contacts getting an abandoned cart email too early.
  ---------------------------------------------------------------------------------------------------- */
  // window.dmPt("identify", "example@example.com");  // Hardcoded example, inject contact email address.
  /* ----------------------------------------------------------------------------------------------------
  Supplying your cart:
  The code below needs to be executed on every single page, after the cart has been created.
  Failure to do so may result in contacts getting an abandoned cart email too early.
  ---------------------------------------------------------------------------------------------------- */
// window.dmPt("cartInsight", {
//
//   // You must setup all of these variables
//   "programID": 123456, // Get this from the Program Builder in dotmailer
//   "cartDelay": 25, // This is the time, in minutes, we wait before sending out the email
//   "cartID": "123ABC", // The ID of your shopping cart, this should be unique
//   "cartPhase": "CUSTOMER_LOGIN", // Set to CUSTOMER_LOGIN on all pages and ORDER_COMPLETE on final page
//   "currency": "USD", // The currency that the prices are in (e.g. USD or GBP)
//   "subtotal": 0.00, // The cart subtotal amount
//   "discountAmount": 0.00, // The amount discounted on the entire order
//   "shipping": 0.00, // The amount of tax included on the entire order
//   "taxAmount": 0, // The amount of tax included on the entire order
//   "grandTotal": 0.00, // The final total of the order, including tax, discounts, etc, if known
//   "cartUrl": "https://www.my-website.com/checkout/cart", // Your website must be able to provide a unique URL to a basket
//
//   /* ----------------------------------------------------------------------------------------------------
//   Setup the cart items
//   For each product in the cart, create an item in the lineItems array.
//   ---------------------------------------------------------------------------------------------------- */
//   "lineItems": [
//     {
//       "sku": "576879",
//       "name": "Shirt",
//       "description": "A super great description of the product",
//       "category": "Shirts > T-Shirts > Blue",
//       "other": "This can be any string value you like",
//       "unitPrice": 11.99,
//       "salePrice": 11.99,
//       "quantity": 2,
//       "totalPrice": 23.98,
//       "imageUrl": "https://i.emlfiles.com/cmpimg/2/3/7/1/8/files/6883804_123eshopim.jpg?w=320&cid=6387806&uid=81732",
//       "productUrl": "http://www.my-website.com/index.php/shirt.html",
//     },
//     {
//       "sku": "1112296",
//       "name": "Fleece Jacket",
//       "description": "A well appointed Fleece jacket",
//       "category": "Shirts > T-Shirts > Blue",
//       "other": "This can be any string value you like",
//       "unitPrice": 65.99,
//       "salePrice": 55.50,
//       "quantity": 1,
//       "totalPrice": 55.50,
//       "imageUrl": "https://i.emlfiles.com/cmpimg/2/3/7/1/8/files/6883804_123eshopim.jpg?w=320&cid=6387806&uid=81732",
//       "productUrl": "http://www.my-website.com/index.php/fleece.html"
//     }
//   ]
// });
